import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import SiteWrapper from './components/SiteWrapper';
import DashboardContainer from './components/DashboardContainer';
import AccountWrapperContainer from './components/AccountWrapperContainer';
import NotFound from './components/NotFound';
import { TABBY_HOME_PAGE_URL, TERMS_OF_SERVICE_URL } from './constants';

import './materialize.css';
import './main.css';

class App extends React.Component {
  static defaultProps = {
    envName: '',
    networkName: '',
    redirectUrl: TABBY_HOME_PAGE_URL,
    givenProvider: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };

    this.handleError = this.handleError.bind(this);
    this.handleRejectTos = this.handleRejectTos.bind(this);
  }

  componentDidMount() {
    this.props.onInit();
  }

  componentWillUnmount() {
    this.props.onShutdown();
  }

  handleError(error) {
    const { onError } = this.props;
    this.setState({ hasError: true });
    onError(error);
  }

  handleRejectTos() {
    window.location.href = this.props.redirectUrl;
  }

  render() {
    const { envName, networkName, givenProvider } = this.props;
    const { hasError } = this.state;

    return (
      <BrowserRouter>
        <SiteWrapper
          envName={envName}
          networkName={networkName}
          onError={this.handleError}
          hasError={hasError}
        >
          <ToastContainer />
          <Switch>
            <Route
              exact
              path="/"
              render={() => (
                <AccountWrapperContainer
                  networkName={networkName}
                  rejectTos={this.handleRejectTos}
                  givenProvider={givenProvider}
                >
                  <DashboardContainer />
                </AccountWrapperContainer>
              )}
            />
            <Route
              exact
              path="/tos"
              render={() => {
                window.location.href = TERMS_OF_SERVICE_URL;
                return 'Redirecting...';
              }}
            />
            <Route component={NotFound} />
          </Switch>
        </SiteWrapper>
      </BrowserRouter>
    );
  }
}

App.propTypes = {
  onInit: PropTypes.func.isRequired,
  onShutdown: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  envName: PropTypes.string,
  networkName: PropTypes.string,
  redirectUrl: PropTypes.string,
  givenProvider: PropTypes.shape({}),
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js